import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Calendar as BigCalendar } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';

import FoodPaybill from '../../../core/FoodPaybill';

import mediaqueries from '../../../../config/themes/variables/mediaqueries';

const WrapperFlex = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${rem('1104px')};
  ${mediaqueries.greaterThan('tablet')`
    padding: 0 ${rem('24px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('58px')} 0 0;
    flex-direction: row;
    justify-content: space-between;
  `};
`;

const WrapperFoodPayFlex = styled.div`
  display: flex;
  justify-content: space-between;
  ${mediaqueries.greaterThan('tablet')`
    justify-content: flex-start;
  `};
  ${mediaqueries.greaterThan('desktop')`
    flex-direction: column;
    width: ${rem('386px')};
  `};
`;

const WrapperCoupons = styled.div`
  padding: ${rem('20px')} 0;
`;

const WrapperCalendar = styled.div`
  width: auto;
  height: ${rem('456px')};
  overflow: hidden;
  ${mediaqueries.greaterThan('tablet')`
    height: ${rem('658px')};
    flex-grow: 1;    
  `};
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('580px')};
  `};
`;

const TitleFoodPay = styled.h2`
  font-size: ${rem('14px')};
  font-family: ${props => props.theme.fonts.bold};
  text-transform: uppercase;
  letter-spacing: 0;
  color: ${props => props.theme.colors.dark};
`;

const StyledFoodPayAvalaible = styled(FoodPaybill)`
  width: 47%;
  ${mediaqueries.greaterThan('tablet')`
    margin-right: ${rem('35px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-right: 0;
    margin-bottom: ${rem('20px')};
    width: 100%;
  `};
`;

const StyledFoodPayConsumed = styled(FoodPaybill)`
  width: 47%;
  ${mediaqueries.greaterThan('desktop')`
    width: 100%;
  `};
`;

const StyledBigCalendarFood = {
  fontFamily: props => props.theme.fonts.medium,
  fontSize: rem('12px'),
  height: rem('347px'),
  transition: 'transform 2s ease-in-out',
  maxWidth: rem('880px'),
  '.rbc-toolbar-label': {
    fontFamily: props => props.theme.fonts.medium,
    fontSize: rem('20px'),
    textTransform: 'uppercase'
  },
  'rbc-month-header': {
    backgroundColor: props => props.theme.colors.grayLighter
  },
  '.rbc-header': {
    border: 'none',
    fontSize: 'inherit',
    fontWeight: 'normal',
    padding: '0 0 0 10px',
    textAlign: 'left',
    textTransform: 'uppercase',
    span: {
      color: props => props.theme.colors.grayDarkest
    }
  },
  '.rbc-header + .rbc-header': {
    border: 'none'
  },
  'rbc-row-bg': {
    backgroundColor: props => props.theme.colors.grayLightest
  },
  '.rbc-month-row + .rbc-month-row, .rbc-day-bg + .rbc-day-bg': {
    borderColor: props => props.theme.colors.light
  },
  '.rbc-month-row': {
    maxHeight: rem('52px'),
    [`@media ${mediaqueries.greaterThan('mobile')}`]: {
      maxHeight: 'inherit'
    }
  },
  '.rbc-date-cell': {
    fontSize: rem('14px'),
    padding: `${rem('5px')} 0 0 0`,
    textAlign: 'center',
    [`@media ${mediaqueries.greaterThan('mobile')}`]: {
      fontSize: rem('16px'),
      padding: `${rem('10px')} 0 0 ${rem('10px')}`,
      textAlign: 'left'
    }
  },
  '.rbc-today': {
    backgroundColor: props => props.theme.colors.grayLight
  },
  '.rbc-event': {
    backgroundColor: 'transparent',
    padding: `0 ${rem('10px')}`
  },
  '.rbc-event.rbc-selected': {
    backgroundColor: props => props.theme.colors.grayLight,
    borderRadius: 0,
    p: {
      color: props => props.theme.colors.grayDarkest,
      ':before': {
        backgroundColor: props => props.theme.colors.activeBlue,
        border: `${rem('2px')} solid ${props => props.theme.colors.success}`
      }
    }
  },
  '.rbc-date-cell.rbc-now': {
    fontWeight: 'normal'
  },
  '.rbc-show-more': {
    backgroundColor: 'transparent',
    color: props => props.theme.colors.grayDarkest,
    fontFamily: props => props.theme.fonts.medium,
    fontSize: rem('12px'),
    fontWeight: 'normal',
    padding: `${rem('5px')} ${rem('10px')}`,
    display: 'none',
    [`@media ${mediaqueries.greaterThan('mobile')}`]: {
      display: 'block'
    }
  },
  'rbc-selected-cell': {
    backgroundColor: props => props.theme.colors.grayLighter
  },
  '.rbc-off-range-bg': {
    backgroundColor: 'transparent'
  },
  '.rbc-off-range': {
    color: props => props.theme.colors.gray
  },
  'rbc-current': {
    backgroundColor: props => props.theme.colors.grayLight,
    color: props => props.theme.colors.grayDarkest,
    fontFamily: props => props.theme.fonts.medium,
    position: 'relative',
    ':after': {
      backgroundColor: props => props.theme.colors.grayLight,
      content: '""',
      height: '370%',
      left: 0,
      position: 'absolute',
      top: 0,
      width: '100%',
      zIndex: -1
    }
  },
  '.rbc-event-content': {
    textAlign: 'center',
    [`@media ${mediaqueries.greaterThan('mobile')}`]: {
      textAlign: 'left'
    }
  },
  [`@media ${mediaqueries.greaterThan('tablet')}`]: {
    height: rem('600px')
  },
  [`@media ${mediaqueries.greaterThan('desktop')}`]: {
    width: '100%'
  }
};

const StyleBigCalendarFood = <BigCalendar style={StyledBigCalendarFood} />;

const StyleEventTitle = styled.p`
  color: ${props => props.theme.colors.dark};
  display: inline;
  font-size: ${rem('12px')};
  font-weight: normal;
  margin: 0;
  max-width: 100%;
  overflow: hidden;
  padding: 10px 0 0 10px;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;

  :before {
    background-color: ${props => props.theme.colors.activeBlue};
    border: ${rem('2px')} solid ${props => props.theme.colors.success};
    border-radius: 50%;
    content: '';
    height: 6px;
    left: 0;
    position: absolute;
    top: 10px;
    width: 6px;
  }

  ${mediaqueries.greaterThan('mobile')`
    display: block;
    padding: 0 0 0 10px;
  `};
`;
const StyleEventText = styled.span`
  display: none;

  ${mediaqueries.greaterThan('mobile')`
    display: inline-block;
    cursor: default;
  `};
`;

export {
  WrapperFlex,
  WrapperFoodPayFlex,
  WrapperCoupons,
  WrapperCalendar,
  TitleFoodPay,
  StyledFoodPayAvalaible,
  StyledFoodPayConsumed,
  StyleBigCalendarFood,
  StyleEventTitle,
  StyleEventText
};
